import "./App.css";
import React, { Suspense } from "react";

import { Navbar, Home, Footer } from "./component";
// import ScrollToTop from "./utils/ScrollToTop";
import BackToTop from './component/backToTop';
const About = React.lazy(() => import("./component/about"));
const Experience = React.lazy(() => import("./component/experience"));
const Skills = React.lazy(() => import("./component/skills"));
const Project = React.lazy(() => import("./component/projects"));
const Contact = React.lazy(() => import("./component/contact"));
const Social = React.lazy(() => import("./component/social"));

function App() {
  return (
    <>
      <div className="Hero">
        <Navbar />
        <Home />
      </div>
      <div className="Hero2">
        <Suspense fallback={<div class="loader"></div>}>
          {/* <ScrollToTop/> */}
          <section id="about">
            <About />
          </section>
          <section id="skills">
            <Skills />
          </section>
          <section id="experience">
            <Experience />
          </section>
          <section id="projects">
            <Project />
          </section>
          <section id="contact">
            <Contact />
          </section>
          <section id="social">
            <Social />
          </section>
        </Suspense>
      </div>
      <BackToTop />
      <Footer />
    </>
  );
}

export default App;
